import { ApiHelper } from './apiHelper';

export class FileUploadApi {
    deleteUpload(filepath, token, callback = null) {
        const deleteUrl = '/api/FileUpload/delete';
        new ApiHelper().deleteDataSecure(deleteUrl, filepath, token, callback);
    }

    uploadFile(upload, token, callback = null) {
        const postUrl = '/api/FileUpload/upload';
        new ApiHelper().postDataSecure(postUrl, upload, token, callback);
    }

    saveFiles(files, token, successCallback = null, failureCallback = null) {
        const postUrl = '/api/FileUpload/saveFiles';
        new ApiHelper().postDataWithResponseSecure(
            postUrl,
            files,
            token,
            successCallback,
            failureCallback
        );
    }
}
